// import exercisesUrl from './requestUrl/exercisesUrl'
export default {
  // exercisesUrl,
  // DocIframeSrc: 'https://openapi.singularity-ai.com/doc/singularity_code_doc_2.html', // 文档页面地址
  DocIframeSrc: 'https://vue.singularity-ai.com/singularity_code_doc.html', // 文档页面地址-- 版本2
  UserAgreementSrc: 'https://openapi.singularity-ai.com/doc/skyCodeUserAgreement.html', // 用户协议页面地址
  PrivacyTermsSrc: 'https://openapi.singularity-ai.com/doc/skyCodePrivacyTerms.html', // 隐私条款页面地址
  
  actionLog: 'https://sa-action.singularity-ai.com/api/v1/action/log', // 记录用户进出页面点击按钮等行为信息

  verifyCode: 'https://sky-account.singularity-ai.com/api/v2/user/sendSMS', // 验证码
  getLogin: 'https://sky-account.singularity-ai.com/api/v2/user/login', // 登录
  loginOut: 'https://sky-account.singularity-ai.com/api/v2/user/logout', // 退出
  loginHeart: 'https://sky-account.singularity-ai.com/api/v1/user/token/login/heart', // 登录页code的心跳函数
  
  // 测试环境 vue
  // actionLog: 'http://39.99.252.222:28066/api/v1/action/log', // 记录用户进出页面点击按钮等行为信息

  // verifyCode: 'http://39.99.252.222:28068/api/v2/user/sendSMS', // 验证码
  // getLogin: 'http://39.99.252.222:28068/api/v2/user/login', // 登录
  // loginOut: 'http://39.99.252.222:28068/api/v2/user/logout', // 退出
  // loginHeart: 'http://39.99.252.222:28068/api/v1/user/token/login/heart', // 登录页code的心跳函数
  
  demoList: 'api/v1/demo/list', // 实例代码接口
}
